import AutoCompleteActionTypes from './types';

const autoComplete = (
  state = {
    optionsList: [],
    loading: false,
    unLoadingPoints: [],
    isFetchingStates: false,
  },
  action: { type: string; payload: any },
) => {
  switch (action.type) {
    case AutoCompleteActionTypes.SEARCH_START:
      return {
        ...state,
        loading: true,
        optionsList: [],
      };

    case AutoCompleteActionTypes.SEARCH_SUCCESS:
      return {
        ...state,
        optionsList: action.payload,
        loading: false,
      };

    case AutoCompleteActionTypes.SEARCH_FAILURE:
      return {
        ...state,
        loading: false,
      };

    case AutoCompleteActionTypes.RESET_LIST:
      return {
        ...state,
        loading: false,
        optionsList: [],
      };
    case AutoCompleteActionTypes.UNLOADING_SEARCH_RESULTS_START:
      return {
        ...state,
        unLoadingPoints: [],
        isFetchingStates: true,
      };
    case AutoCompleteActionTypes.UNLOADING_SEARCH_RESULTS_SUCCESS:
      return {
        ...state,
        unLoadingPoints: action.payload.data.data,
        isFetchingStates: false,
      };
    case AutoCompleteActionTypes.UNLOADING_SEARCH_RESULTS_FAILURE:
      return {
        ...state,
        unLoadingPoints: [],
        isFetchingStates: false,
      };

    default:
      return state;
  }
};

export default autoComplete;
